import React from "react";
import {
  t,
  HEADING1,
  HEADING2,
  P1,
  HEADING3,
  P2,
  P3,
  P4,
  P5,
  P6,
  P7,
  HEADING4,
  P8,
  HEADING5,
  P9,
  HEADING6,
  P10,
  HEADING7,
  P11,
  HEADING8,
  P12,
  HEADING9,
  P13,
  HEADING10,
  P14,
  HEADING11,
  P15,
  LI1_1,
  LI1_2,
  LI2_1,
  LI2_2,
  LI3_1,
  LI3_2,
  HEADING12,
  P16,
  HEADING13,
  LI4,
  LI5,
  LI6,
  HEADING14,
  P17,
  HEADING15,
  P18,
} from "../../translations/AboutUs/LabourWelfare";

function LabourWelfare() {
  return (
    <div
      style={{
        width: "80%",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        flexDirection: "column",
        gap: 15,
        paddingRight: 10,
      }}
    >
      <div
        className="a-large"
        style={{ fontWeight: 600, textAlign: "left" }}>
        {t(HEADING1)}
      </div>
      <div className="a-normal" style={{ fontWeight: 500 }}>{t(HEADING2)}</div>
      <div className="a-normal" style={{ fontWeight: 600, paddingLeft: 120 }}>
        {t(P1)}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          paddingLeft: 35,
          gap: 10,
        }}
      >
        <div className="a-normal" style={{ fontWeight: 600 }}>{t(HEADING3)}</div>
        <div className="a-regular" style={{ fontWeight: 400 }}>
          {t(P2)} <br />
          {t(P3)}
        </div>
        <ul style={{ margin: 0, padding: 0, marginLeft: 52 }}>
          <li className="a-regular" style={{ fontWeight: 400 }}>
            {t(P4)} <br />
            {t(P5)}
          </li>
          <li className="a-regular" style={{ fontWeight: 400 }}>
            {t(P6)} <br />
            {t(P7)}
          </li>
        </ul>
        <div className="a-normal" style={{ fontWeight: 600 }}>{t(HEADING4)}</div>
        <div className="a-regular" style={{ fontWeight: 400, textAlign: "justify" }}>
          {t(P8)}
        </div>
        <div className="a-normal" style={{ fontWeight: 600 }}>{t(HEADING5)}</div>
        <div className="a-regular" style={{ fontWeight: 400, textAlign: "justify" }}>
          {t(P9)}
        </div>
        <div className="a-normal" style={{ fontWeight: 600 }}>{t(HEADING6)}</div>
        <div className="a-regular" style={{ fontWeight: 400, textAlign: "justify" }}>
          {t(P10)}
        </div>
        <div className="a-normal" style={{ fontWeight: 600 }}>{t(HEADING7)}</div>
        <div className="a-regular" style={{ fontWeight: 400, textAlign: "justify" }}>
          {t(P11)}
        </div>
        <div className="a-normal" style={{ fontWeight: 600 }}>{t(HEADING8)}</div>
        <div className="a-regular" style={{ fontWeight: 400, textAlign: "justify" }}>
          {t(P12)}
        </div>
        <div className="a-normal" style={{ fontWeight: 600 }}>{t(HEADING9)}</div>
        <div className="a-regular" style={{ fontWeight: 400, textAlign: "justify" }}>
          {t(P13)}
        </div>
        <div className="a-normal" style={{ fontWeight: 600 }}>{t(HEADING10)}</div>
        <div className="a-regular" style={{ fontWeight: 400, textAlign: "justify" }}>
          {t(P14)}
        </div>
        <div className="a-normal" style={{ fontWeight: 600, color: "#202020" }}>
          {t(HEADING11)}
        </div>
        <div className="a-regular" style={{ fontWeight: 400, textAlign: "justify" }}>
          {t(P15)}
        </div>
        <ul style={{ margin: 0, padding: 0, marginLeft: 52, color: "#444444" }}>
          <li className="a-regular" style={{ fontWeight: 400, textAlign: "justify" }}>
            <span style={{ fontWeight: 600, color: "#444444" }}>
              {t(LI1_1)}
            </span>
            {t(LI1_2)}
          </li>
          <li className="a-regular" style={{ fontWeight: 400, textAlign: "justify" }}>
            <span style={{ fontWeight: 600, color: "#444444" }}>
              {t(LI2_1)}
            </span>
            {t(LI2_2)}
          </li>
          <li className="a-regular" style={{ fontWeight: 400, textAlign: "justify" }}>
            <span style={{ fontWeight: 600, color: "#444444" }}>
              {t(LI3_1)}
            </span>
            {t(LI3_2)}
          </li>
        </ul>
        <div className="a-normal" style={{ fontWeight: 600 }}>{t(HEADING12)}</div>
        <div className="a-regular" style={{ fontWeight: 400, textAlign: "justify" }}>
          {t(P16)}
        </div>
        <div className="a-normal" style={{ fontWeight: 600 }}>{t(HEADING13)}</div>
        <ul style={{ margin: 0, padding: 0, marginLeft: 52 }}>
          <li className="a-regular" style={{ fontWeight: 400, textAlign: "justify" }}>
            {t(LI4)}
          </li>
          <li className="a-regular" style={{ fontWeight: 400, textAlign: "justify" }}>
            {t(LI5)}
          </li>
          <li className="a-regular" style={{ fontWeight: 400, textAlign: "justify" }}>
            {t(LI6)}
          </li>
        </ul>
        <div className="a-normal" style={{ fontWeight: 600 }}>{t(HEADING14)}</div>
        <div className="a-regular" style={{ fontWeight: 400, textAlign: "justify" }}>
          {t(P17)}
        </div>
        <div className="a-normal" style={{ fontWeight: 600 }}>{t(HEADING15)}</div>
        <div className="a-regular" style={{ fontWeight: 400, textAlign: "justify" }}>
          {t(P18)}
        </div>
      </div>
    </div>
  );
}

export default LabourWelfare;
